import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Timezone } from '@app/shared/models/timezone.model';
import { TimezoneService } from '@core/services/timezone.service';
import { TimezoneAdapter } from '@core/services/adapters/timezone.adapter';

@Injectable()
export class TimezonesStoreService {
    private timezones: Timezone[] = [];

    constructor(
        private timezoneService: TimezoneService,
        private timezoneAdapter: TimezoneAdapter
    ) {}

    setTimezones(): Observable<Timezone[]> {
        if (this.timezones.length) {
            return of(this.timezones);
        }

        return this.timezoneService.getTimezones().pipe(tap((result) => (this.timezones = result)));
    }

    getTimezones(): Timezone[] {
        return this.timezones;
    }

    getTimezoneByCode(code: string): Timezone {
        return (
            this.timezones.find((tz: Timezone) => tz.code === code) ??
            this.timezoneAdapter.adapt({})
        );
    }

    getTimezoneByOffsetCode(offsetCode: string): Timezone {
        return (
            this.timezones.find((tz: Timezone) => tz.offsetCode === offsetCode) ??
            this.timezoneAdapter.adapt({})
        );
    }
}
